const COMMON_UI_WORDS = new Set([
  'add','apply','back','cancel','click','close','confirm','continue','delete',
  'download','edit','export','filter','help','here','home','import','menu','next',
  'open','previous','reset','save','search','settings','start','stop','submit',
  'update','upload','view','yes','no','ok','okay','accept','decline'
]);

const sanitizeTextForDisplay = (text, { maxLength = 30 } = {}) => {
  if (!text) return '';

  let sanitized = text;

  // Normalize whitespace for consistent matchings
  sanitized = sanitized.replace(/\s+/g, ' ').trim();

  // Remove MRN patterns (e.g. "MRN: 12345", "MRN#991122", "Medical Record Number 778899")
  sanitized = sanitized.replace(/\b(?:MRN|MRN#|MRN:|MRN No\.?|MRN Number|Medical\s*Record\s*(?:Number|No\.?))[:#\s-]*\d{3,}\b/gi, '[MRN]');

  // Remove generic patient/encounter identifiers (Account ID, Patient ID, etc.)
  sanitized = sanitized.replace(/\b(?:Patient|EncountAccount|Visit|Record|Chart)\s*(?:ID|Identifier|Number|No\.?)[:#\s-]*\d{3,}\b/gi, '[ID]');

  // Replace long digit sequences (6+ digits) that commonly represent identifiers
  sanitized = sanitized.replace(/\b\d{6,}\b/g, '[ID]');

  // Remove SSN patterns (XXX-XX-XXXX)
  sanitized = sanitized.replace(/\b\d{3}-\d{2}-\d{4}\b/g, '[SSN]');

  // Remove DOB patterns (common formats)
  sanitized = sanitized.replace(/\b\d{1,2}\/\d{1,2}\/\d{2,4}\b/g, '[DOB]');
  sanitized = sanitized.replace(/\b\d{4}-\d{2}-\d{2}\b/g, '[DOB]');
  sanitized = sanitized.replace(/\b(?:DOB|Date\s*of\s*Birth)[:#\s-]*\d{1,2}[\/-]\d{1,2}[\/-]\d{2,4}\b/gi, '[DOB]');

  // Remove phone patterns (XXX-XXX-XXXX or (XXX) XXX-XXXX)
  sanitized = sanitized.replace(/\b\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}\b/g, '[PHONE]');

  // Remove email addresses
  sanitized = sanitized.replace(/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g, '[EMAIL]');

  // Remove common patient name prefixes (if followed by typical name patterns)
  sanitized = sanitized.replace(/\b(Patient|Patient Name|Name)[:\s-]+[^:,;\n]+/gi, '[PATIENT]');

  // Handle "Lastname, Firstname" formatted names
  sanitized = sanitized.replace(/\b[A-Z]{2,}[A-Z\s\-']*,\s*[A-Z][a-zA-Z'\-]+(?:\s+[A-Z][a-zA-Z'\-]+)?\b/g, '[PATIENT]');

  // Handle uppercase MRN-type identifiers embedded in IDs (e.g., patient_12345, MRN-12345)
  sanitized = sanitized.replace(/\b(h\d+|bed_\d+|patient[_-]?\w+|mrn[_-]?\d+)\b/gi, '[ID]');

  // Redact likely "First Last" style names while skipping common UI words
  sanitized = sanitized.replace(/\b([A-Z][A-Za-z'\-]+(?:\s+[A-Z][A-Za-z'\-]+)+)\b/g, (match) => {
    const words = match.split(/\s+/);
    if (words.length < 2 || words.length > 3) {
      return match;
    }

    const nonUiWords = words.filter(word => !COMMON_UI_WORDS.has(word.toLowerCase()));
    if (nonUiWords.length === 0) {
      return match;
    }

    // Require at least two words that look like names (contain vowels & length > 2)
    const likelyNameWords = nonUiWords.filter(word => word.length > 2 && /[aeiou]/i.test(word));
    if (likelyNameWords.length >= 2) {
      return '[PATIENT]';
    }

    return match;
  });

  // Collapse repeated placeholders (e.g., "[PATIENT] [PATIENT]")
  sanitized = sanitized.replace(/(?:\[PATIENT\]\s*){2,}/g, '[PATIENT]');

  // If after sanitization we removed everything, return a generic placeholder
  if (sanitized.trim().length === 0) {
    return '[Data]';
  }

  return sanitized.substring(0, maxLength);
};

export { COMMON_UI_WORDS };
export default sanitizeTextForDisplay;